import React, { useEffect, useState, useCallback } from "react";
import "./AboutModal.scss";

const AboutModal = ({ onClose, username, avatar, createdAt }) => {
  const [isClosing, setIsClosing] = useState(false);

  const formattedDate = createdAt
    ? new Date(createdAt).toLocaleDateString("uk-UA", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "";

  const handleClose = useCallback(() => {
    if (isClosing) return;
    setIsClosing(true);
    setTimeout(() => onClose?.(), 250);
  }, [isClosing, onClose]);

  useEffect(() => {
    const body = document.body;
    const prev = body.style.overflow;
    body.style.overflow = "hidden";
    return () => {
      body.style.overflow = prev || "";
    };
  }, []);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && handleClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [handleClose]);

  return (
    <div
      className={`about-modal-overlay ${isClosing ? "is-closing" : ""}`}
      onClick={handleClose}
    >
      <div
        className="about-modal-shell"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="about-modal">
          <img src={avatar} alt="Avatar" className="about-avatar" />
          <h3>{username}</h3>
          {createdAt && (
            <p className="joined-date">на Cvanto з {formattedDate}</p>
          )}
          <button onClick={handleClose}>Закрити</button>
        </div>
      </div>
    </div>
  );
};

export default AboutModal;
